module.exports = __webpack_public_path__ + "static/media/icon-shorthaul.6d2a1e54.svg";